import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { EditCompanyPanelController } from '../controller/EditCompanyPanelController';
import { CompanyData } from '../../../types/company-data';
import { GzDialogWebComponent } from '../../../../ui/gzDialog';

export class EditCompanyPanelWebComponent extends BaseWebComponentElement {
  public controller!: EditCompanyPanelController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EditCompanyPanelController,
    });
  }

  public get editedCompanyId(): string {
    const editedCompanyId = this.getAttribute('editedCompanyId');

    if (!editedCompanyId) {
      throw new Error('[EditCompanyPanel] "editedCompanyId" not provided as an attribute.');
    }

    return editedCompanyId;
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.hasUnsavedChanges;
  }

  public get isPlayingVideo(): boolean {
    return this.controller.view.isVideoPlaying;
  }

  public set sideMenuParentDialog(parent: GzDialogWebComponent) {
    this.controller.view.sideMenuParentDialog = parent;
  }

  public refreshCompanyDetailsTab(company: CompanyData) {
    // guard against undefined
    const companyDetailsReference = this.controller.view.dom.companyDetails;
    const companyDetailsFormReference = companyDetailsReference && companyDetailsReference.$companyDetailsForm;
    if (companyDetailsFormReference) {
      this.controller.view.dom.companyDetails.$companyDetailsForm.setEditedCompanyData(company);
      this.controller.view.dom.companyDetails.$companyDetailsForm.updateManageNetworkSection(true);
      this.controller.view.dom.companyDetails.$companyDetailsForm.setupMdrContactDetailsSection();
    }
  }

  public refreshCompanyMspInProductTrialsTab(company: CompanyData) {
    this.controller.view.dom.$mspInProductTrials.setTrialFeatures(
      company.specifics.features,
      company.specifics.mspInProductTrials
    );
    this.updateCompanyInfoForMspProductTrials(company);
    this.controller.view.dom.$mspInProductTrials.refreshTab();
  }

  public updateCompanyInfoForMspProductTrials(company: CompanyData) {
    this.controller.view.dom.$mspInProductTrials.setCompanySelectedCountry(company.specifics.country);
    this.controller.view.dom.$mspInProductTrials.setCompanySelectedIndustry(company.specifics.industry as number);
    this.controller.view.dom.$mspInProductTrials.setCompanySelectedState(company.specifics.state);
  }
}
